$(document).on('click', '.main_blog_layout .menu-item a', function (e) {
 

  const $this = $(this);
  const target = $this.attr('href');
  const el = document.querySelector(target);

  if (el) {
    const offset = 150;
    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

    // active class
    $('.main_blog_layout .menu-item a').removeClass('active');
    $this.addClass('active');

    // scroll page
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });

    // scroll menu into view
    scrollMenuToActive($this);
  }
});


function updateActiveMenu() {
  // let scrollPos = $(window).scrollTop();

  // $('.main_blog_layout .menu-item a').each(function () {
  //   const target = $(this).attr('href');

  //   if ($(target).length) {
  //     const top = $(target).offset().top - 200;
  //     const bottom = top + $(target).outerHeight();

  //     if (scrollPos >= top && scrollPos < bottom) {
  //       $('.main_blog_layout .menu-item a').removeClass('active');
  //       $(this).addClass('active');

  //       scrollMenuToActive($(this));
  //     }
  //   }
  // });
}
function scrollMenuToActive($activeItem) {
  const $container = $('.menu_scroller_wrap');

  if (!$container.length) return;

  const containerLeft = $container.scrollLeft();
  const containerWidth = $container.width();

  const itemLeft = $activeItem.position().left + containerLeft;
  const itemWidth = $activeItem.outerWidth();

  const scrollTo = itemLeft - (containerWidth / 2) + (itemWidth / 2);

  $container.stop().animate({
    scrollLeft: scrollTo
  }, 300);
}
// run on scroll
$(window).on('scroll', function () {
  updateActiveMenu();
});

// run on load
$(window).on('load', function () {
  updateActiveMenu();
});



function scrollMenuToActive($activeItem) {
    const $container = $('.menu_scroller_wrap');
    if (!$container.length) return;

    const containerLeft = $container.scrollLeft();
    const containerWidth = $container.width();

    const itemLeft = $activeItem.position().left + containerLeft;
    const itemWidth = $activeItem.outerWidth();

    const scrollTo = itemLeft - (containerWidth / 2) + (itemWidth / 2);

    $container.stop().animate({
      scrollLeft: scrollTo
    }, 300);
  }


document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll('.heading_image_sub, .product_grid_wwrap');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      if (entry.isIntersecting) {

        const id = entry.target.id;
      
        if (!id) return;

        const $link = $('.menu_scroller_wrap a[href="#' + id + '"]');
        console.log("LINK:", $link.length);

        if ($link.length && !$link.hasClass('active')) {
          $('.menu_scroller_wrap a').removeClass('active');
          $link.addClass('active');

          scrollMenuToActive($link);
        }
      }

    });
  }, {
    threshold: 0.1, // 🔥 FIXED
    rootMargin: "-100px 0px -40% 0px"
  });

  sections.forEach(section => observer.observe(section));

});
$(document).ready(function(){


function updateCartCount(cart) {
  try {
    const count = cart.item_count;

    const cartCountEl = document.querySelector('cart-count');
    if (cartCountEl) {
      cartCountEl.textContent = count;
      cartCountEl.setAttribute('aria-label', `${count} items`);
    }

    const bubbles = document.querySelectorAll('#cart-icon-bubble, .cart-count-bubble');
    bubbles.forEach(el => {
      el.textContent = count;
    });

  } catch (e) {
    console.error('Cart count error:', e);
  }
}


// =========================
// UPDATE CART DRAWER
// =========================
function updateCartDrawer(cartData = null) {
  try {
   

    if (cartData) {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { cart: cartData }
      }));
    }

    const cartButton =
    document.querySelector(".cart-drawer-button")
     
    if (cartButton) {
      cartButton.click();
      return;
    }


  
    const drawer = document.querySelector('#CartDrawer');
    if (drawer) {
      drawer.classList.add('active', 'animate');
      document.body.classList.add('cart-drawer-open');
    }

  } catch (err) {
    console.error('Cart error:', err);
  }
}

$('.atc_btn').on('click', function(e) {

  $(this).text("Adding...");

  e.preventDefault();

  const variantId = parseInt($(this).attr("var-id"));

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: 1
    },
    dataType: 'json',
    success: function(response) {
      
  $(".atc_btn").text("Add To Cart");
         console.log("success")
  fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {

          updateCartCount(cart);   // 🔥 update count
          updateCartDrawer(cart);  // 🔥 open drawer
        });


    },
    error: function(err) {
       $(this).text("Failed");
      setTimeout(() => {
         $(this).text("Add To Cart");
      }, 300);
      
      console.log(err);
    }
  });
});


})
document.addEventListener('click', function (e) {
  // Find the close button only when cart drawer is open
  const closeBtn = e.target.closest(
    '.drawer__close-btn.z-1.static'
  );

  if (!closeBtn) return;

  // Find the opened cart drawer
  const cartDrawer = document.querySelector(
    'cart-drawer[open]'
  );

  if (cartDrawer) {
    cartDrawer.removeAttribute('open');
  }
});

